import { mergeClasses } from "@fluentui/react-components";
import * as React from "react";
import { AppNavItem } from "./AppNavItem.web";
import type { App } from "./AppNavItem.web.data";
import { useStyles } from "./AppNavList.web.styles";

export const AppNavList: React.FC<{
  expanded: boolean;
  apps: App[];
  onInit: (hasOverflow: boolean) => void;
}> = ({ expanded, apps, onInit }) => {
  const styles = useStyles();
  const ulRef = React.useRef<HTMLUListElement>(null);

  React.useEffect(() => {
    const handleResize = () => {
      if (ulRef.current) {
        const hasOverflow =
          ulRef.current.scrollHeight > ulRef.current.clientHeight;
        onInit(hasOverflow);
      }
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [onInit]);

  return (
    <ul
      ref={ulRef}
      id="app-nav-list"
      data-testid={expanded ? "app-nav-list-expanded" : "app-nav-list"}
      className={mergeClasses(
        styles.ul,
        expanded ? styles.ulExpanded : undefined
      )}
    >
      {apps.map((app) => (
        <AppNavItem app={app} expanded={expanded} key={app.link} />
      ))}
    </ul>
  );
};
